import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../../shared/services/auth.service';
import { ICommittee } from '../../../../committees/shared/models/committee';
import { CommitteeService } from '../../../../committees/shared/services/committee.service';
import { UserUtility } from '../../../../../shared/utilities/user-utility';
import { IUser } from '../../../../../shared/models/user';

@Component({
    selector: 'app-project-details-overview-project-details',
    templateUrl: './project-details-overview-project-details.component.html',
    styleUrl: './project-details-overview-project-details.component.scss',
    standalone: false
})
export class ProjectDetailsOverviewProjectDetailsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() committeeCode: string | null = null;

  loading: boolean = true;
  subscriptions: Subscription = new Subscription();

  currentUser: IUser | null = null;
  canViewAllCommitteeDetails: boolean = false;

  committee: ICommittee | null = null;

  constructor(
    private _authService: AuthService,
    private _commtteeService: CommitteeService,
  ) {
  }

  ngOnInit(): void {
    const userSubscription = this._authService.currentUserSubject.subscribe(user => {
      if (user) {
        this.currentUser = user;
        this.setUserPermissions();
      }
    });

    this.subscriptions.add(userSubscription);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const committeeCode = changes['committeeCode'];
    
    if(!committeeCode?.currentValue){
      return;
    }

    this.committeeCode = committeeCode.currentValue;
    this.getCommittee();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  setUserPermissions() {
    if (!this.committeeCode) {
      this.loading = false;
      return;
    }

    if(this.currentUser){
      this.canViewAllCommitteeDetails = UserUtility.isInternalUser(this.currentUser)
        || UserUtility.userIsOnCommittee(this.currentUser, this.committeeCode);
    }
  }

  getCommittee() {
    if (!this.committeeCode) {
      return;
    }

    this.loading = true;
    const getCommitteeSubscription = this._commtteeService
      .getCommittee(this.committeeCode)
      .subscribe({
        next: response => {
          if (response.success) {
            this.committee = response.content;
          }

          this.loading = false;
        },
        error: _ => {
          this.loading = false;
        },
      });

    this.subscriptions.add(getCommitteeSubscription);
  }
}
